import service from '../axios'

/**
 * 页面配置相关API接口
 */
const pageAPI = {
  /**
 * 获取页面配置
 * @param {string} page - 页面名称，默认为'home'
 * @returns {Promise} - 返回页面配置数据
 */
  getPageConfig(page = 'home') {
    return service.get(`/page-config?page=${page}`)
  },

  /**
   * 更新页面配置
   * @param {Object} configData - 配置数据
   * @returns {Promise} - 返回更新结果
   */
  updatePageConfig(configData) {
    return service.post('/page-config', configData)
  }
}

export default pageAPI